<div [@expandCollapseSidebar]="expanded" id="custom-sidebar"
  class=" w-full hide-scrollbar bg-background backdrop-blur-2xl fixed h-screen max-h-screen bg-transparent  {{expanded ? 'p-2 rounded-r-2xl' : 'p-4'}}  {{isMobile ? 'sidebar-mobile' : 'sidebar-desktop'}}">

  <div class=" flex flex-col justify-start gap-2 p-1 transition-all duration-300"
    style="height: 85vh;max-height: 85vh;">
    <!--Logo-->
    <div class="relative flex flex-col justify-center items-center w-full my-2" style="height: 15%;">
      <a class="logo-main" routerLink="/home/dashboard">
        <!-- <img src="{{logoPath}}" class="logo-main" alt="logo" id="app-logo-sidebar" #appLogo> -->
        <!--<img src="assets/images/temp/LogoSera-black.svg" class="mr-2 logo-main"
          alt="logo">-->
        <div class="logo-main" #appLogo>
          <h1 class="font-black" style="font-size: 100%;">FIX.APP</h1>
        </div>
      </a>
    </div>
    <div class=" border-b-2 border-primary-200 w-full"></div>



    <div
      class="overflow-hidden {{!expanded ? 'userCard' : 'userCardShrink'}} transition-all duration-300 flex justify-between items-center  w-full text-colored text-start bg-primary-50 user-card rounded-3xl p-2">

      <div [routerLink]="'/home/user/info'"
        class="flex items-center text-coloredrounded-xl w-1/6 cursor-pointer transition-all duration-300 ">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
          <path d="M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
          <path d="M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855" />
        </svg>

      </div>

      <div id="username" class="flex flex-col  w-4/6">

        <p class=" text-xl font-medium whitespace-nowrap text-ellipsis overflow-hidden">{{userData.user.username}}</p>


        <span id="roles" class="text-xs whitespace-nowrap text-ellipsis overflow-hidden">
          <span *ngFor="let role of userData.roles, let i = index">{{role}}<span
              *ngIf="i < userData?.roles!.length -1">, </span> </span>
        </span>
      </div>


      <!--     <button [matMenuTriggerFor]="menu">Menu</button> -->

      <!-- <div tabindex="0" [matMenuTriggerFor]="menu"
        class="flex items-center text-primary-500 hover:bg-primary-500 hover:text-white rounded-xl  p-2 cursor-pointer transition-all duration-300 ">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="w-6 h-6">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M12 5l0 14" />
          <path d="M5 12l14 0" />
        </svg>

      </div> -->

      <div (click)="showButton()" class=" w-1/6">

        <div class="p-2 w-full transition-transform duration-300 flex justify-center items-center"
          [ngClass]="{'rotate-180': displayOptions, 'rotate-180 3': !displayOptions}">
          <svg *ngIf="!displayOptions" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>

          <svg *ngIf="displayOptions" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />
          </svg>
        </div>

      </div>


      <mat-menu #menu="matMenu" hasBackdrop="true" backdropClass="bg-black/20">


        <div class="flex flex-col justify-center items-center gap-2">


          <div tabindex="0"
            class="flex items-center gap-2 text-primary-500 bg-primary-50 hover:bg-primary-500 hover:text-white rounded-2xl w-full  p-2 cursor-pointer transition-all duration-300 "
            (click)="settings()">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
              <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
            </svg>
            <p>Impostazioni</p>

          </div>


          <div *ngIf="!expanded" tabindex="0"
            class="flex items-center gap-2 border-2 bg-red-50  w-full text-red-500 hover:bg-red-500 hover:text-white rounded-2xl  p-2 cursor-pointer transition-all duration-300 "
            (click)="logout()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
              <path d="M9 12h12l-3 -3" />
              <path d="M18 15l3 -3" />
            </svg>
            <p>Logout</p>

          </div>

          <!-- <button (click)="stampa(true)" class="dl-button p-2 flex items-center gap-1 w-full rounded-2xl">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" />
              <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" />
              <path d="M7 13m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z" />
            </svg>
            Stampa Preventivo
          </button>
          <button *ngIf="isCliente" (click)="stampa(true,true)"
            class="dl-button p-2 flex items-center gap-1 w-full rounded-2xl">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" />
              <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" />
              <path d="M7 13m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z" />
            </svg>
            Stampa Preventivo con ricarico
          </button>

          <button (click)="stampa(false)" class="dl-button p-2 flex items-center gap-1 w-full rounded-2xl">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" />
              <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" />
              <path d="M7 13m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z" />
            </svg>
            Stampa Distinta di Posa
          </button> -->
        </div>

      </mat-menu>


    </div>


    <div @slideDownUp class=" w-full flex flex-col text-center bg-primary-50 p-2 rounded-3xl" id="options"
      *ngIf="displayOptions">


      <div class="mt-2 flex flex-col gap-2">


        <div
          class="flex items-center gap-2 text-white bg-primary-500 hover:bg-primary-700 hover:text-white rounded-2xl w-full  p-2 cursor-pointer transition-all duration-300 "
          (click)="settings()">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 mr-2" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path
              d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
            <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
          </svg>
          <p>Impostazioni</p>
        </div>


        <div
          class="flex items-center gap-2 bg-red-50  w-full text-red-500 hover:bg-red-500 hover:text-white rounded-2xl  p-2 cursor-pointer transition-all duration-300 "
          (click)="logout()">

          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 mr-2" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M10 8v-2a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2" />
            <path d="M15 12h-12l3 -3" />
            <path d="M6 15l-3 -3" />
          </svg>


          <p>Esci</p>
        </div>

      </div>

    </div>

    <!--Menu-->
    <div
      class="relative overflow-auto hide-scrollbar rounded-2xl transition-all duration-300 {{expanded ? 'menu-collapsed' : 'menu-expanded'}}">
      <!--<app-menu>
  
        </app-menu>
        <div class="my-4"></div>-->

      <div *ngIf="data.length > 0">
        <div class="my-1">
          <app-tree [expanded]="expanded" [data]="data" #tree (onNodeClick)="onNodeSelected($event)">

          </app-tree>

        </div>

      </div>
      <div *ngIf="data.length == 0" class="text-left flex justify-around items-start h-full ">
        <!--<div class=" lds-dual-ring ">
          </div>-->
        <div class="flex flex-col mt-4">

          <ng-container *ngFor="let _ of [].constructor(15)">

            <div class="loading-place-holder text-left flex mt-3">
              <ejs-skeleton shape="text" shimmerEffect height="20px" width="20px"
                style="margin-right: 8px;"></ejs-skeleton>
              <ejs-skeleton shape="text" shimmerEffect height="20px" width="220px"></ejs-skeleton>
            </div>

          </ng-container>

        </div>
      </div>

    </div>

  </div>



  <div class="flex justify-center items-center gap-2 w-full p-2" style="max-height: 10vh;">


    <!--   <div tabindex="0"
      class="flex items-center text-primary-500 hover:bg-primary-500 hover:text-white rounded-xl w-12 h-12  border-primary-500 border-2  p-2 cursor-pointer transition-all duration-300 "
      (click)="settings()">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-full h-fit" viewBox="0 0 24 24" stroke-width="1.5"
        stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path
          d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
        <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
      </svg>

    </div>


    <div *ngIf="!expanded" tabindex="0"
      class="flex items-center border-red-500 border-2 w-12 h-12 text-red-500 hover:bg-red-500 hover:text-white rounded-xl  p-2 cursor-pointer transition-all duration-300 "
      (click)="logout()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" class="w-full h-fit">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
        <path d="M9 12h12l-3 -3" />
        <path d="M18 15l3 -3" />
      </svg>

    </div> -->




  </div>



</div>